<template lang="pug">
#filtros-novo-monitoramento.view-container
    .filtros
        .pesquisa-inteligente__container
            .pesquisa-inteligente__barra-pesquisa
                i.el-icon-search
                input(
                    v-model='pesquisa',
                    type='text',
                    placeholder='Buscar territórios por nome, CAR, pessoa, Documento ou  ID da Pessoa',
                    autocomplete='off',
                    @keyup.enter='pesquisar',
                    @blur='fecharLista'
                )

            .pesquisa-inteligente__resultado
                transition(name='el-zoom-in-top')
                    ul.pesquisa-inteligente__ul(v-if='mostrarOpcoes')
                        .mb-2(v-for='opcao in opcoes')
                            span.pesquisa-inteligente__categoria(
                                v-if='opcao.resultado.length'
                            ) {{ opcao.categoria }}

                            li(
                                v-for='resultado in opcao.resultado',
                                @click='selecionarResultado(resultado, opcao.codigo)'
                            )
                                span {{ resultado.valor }}

        .filtros-avancados
            el-popover(placement='bottom', width='500', trigger='click')
                el-button.button-outline(
                    icon='lyra-icon lyra-filtro',
                    name='filtro',
                    plain,
                    slot='reference'
                ) Filtros Avançados

                el-form.filtro(label-position='top')
                    .filtros-avancados__cabecalho.mb-3
                        .filtros-avancados__titulo
                            b Filtros avançados
                        .filtros-avancados__aplicar-filtro(
                            @click='aplicarFiltros'
                        )
                            | Aplicar filtro

                    .filtros-avancados__collapse
                        el-form-item
                            el-collapse(
                                v-model='collapseFiltroAvancado',
                                accordion,
                                @change='abrirCollapse'
                            )
                                el-collapse-item(title='Biomas', name='biomas')
                                    .el-collapse-item__biomas(
                                        v-loading='!biomas.length'
                                    )
                                        el-radio(
                                            v-for='(bioma, index) in biomas',
                                            v-model='biomaSelecionado',
                                            :label='bioma',
                                            :key='index + bioma.nome'
                                        )
                                            | {{ bioma.nome }}

                                el-collapse-item(
                                    title='UF/Município',
                                    name='estados'
                                )
                                    .filtros-avancados-popover__select(
                                        v-loading='!estados.length'
                                    )
                                        el-select(
                                            v-model='estadoSelecionado',
                                            filterable,
                                            value-key='id',
                                            @change='buscarMunicipios()',
                                            placeholder='UF'
                                        )
                                            el-option(
                                                v-for='(estado, index) in estados',
                                                :key='estado.id',
                                                :label='estado.nome',
                                                :value='estado'
                                            ) {{ estado.nome }}

                                        el-select(
                                            v-model='municipioSelecionado',
                                            filterable,
                                            value-key='id',
                                            placeholder='Município'
                                        )
                                            el-option(
                                                v-for='(municipio, index) in municipios',
                                                :key='municipio.id',
                                                :label='municipio.nome',
                                                :value='municipio'
                                            ) {{ municipio.nome }}

    .pesquisa-inteligente-novo-monitoramento__filtros-selecionados.mt-3
        span.filtros-selecionados__titulo Filtros selecionados:
        el-tag.filtros-selecionados__tags(
            v-for='tag in tags',
            :key='tag.nome',
            closable='',
            type='success',
            @close='removerFiltro(tag)'
        )
            span {{ tag.nome }}

        el-tag.filtros-selecionados__limpar(
            v-if='tags.length',
            type='info',
            @click='limparFiltros'
        ) Limpar filtros
            i.el-icon-delete

        span.filtros-selecionados__vazio(v-else) Nenhum filtro selecionado
</template>

<script>
import FomularioFiltroAvancadoMonitoramento from '@/components/monitoramento/FomularioFiltroAvancadoMonitoramento';
import PesquisaInteligenteService from '@/services/PesquisaInteligenteService';
import BiomaService from '@/services/BiomaService';
import LocalidadeService from '@/services/LocalidadeService';

export default {
    name: 'FiltrarTerritorioMonitoramento',
    props: {
        isMonitoramentoSocioambiental: {
            type: Boolean,
            default: () => false
        }
    },

    components: {
        FomularioFiltroAvancadoMonitoramento
    },
    data() {
        return {
            pesquisa: '',
            opcoes: [],
            mostrarOpcoes: false,
            collapseFiltroAvancado: '',

            biomas: [],
            biomaSelecionado: '',
            estados: [],
            estadoSelecionado: '',
            municipios: [],
            municipioSelecionado: '',
            tags: [],
            resultadosSelecionados: [],
            acaoCollapse: {
                biomas: {
                    collapse: 'biomas',
                    callback: 'buscarBiomas'
                },
                estados: {
                    collapse: 'estados',
                    callback: 'buscarEstados'
                }
            }
        };
    },
    mounted() {
        this.validarRotaComParametro();
        this.validarRotaSemParametro();
    },
    methods: {
        async pesquisar() {
            const { data } =
                await PesquisaInteligenteService.realizarPesquisaTerritorios(
                    this.pesquisa
                );
            this.opcoes = data;

            let resultadoValido = false;
            for (const opcao of this.opcoes) {
                if (opcao.resultado.length !== 0) {
                    resultadoValido = true;
                    break;
                }
            }
            this.mostrarOpcoes = !!resultadoValido;

            if (!this.mostrarOpcoes) {
                this.$notify.warning({
                    message:
                        'Não foram encontrados resultados com o texto informado'
                });
            }
        },

        fecharLista() {
            setTimeout(() => {
                this.mostrarOpcoes = false;
            }, 300);
        },

        selecionarResultado(resultado, categoria) {
            this.adicionarResultado(resultado, categoria);
            this.pesquisa = '';
            this.aplicarFiltros();
        },

        adicionarResultado(resultado, categoria) {
            const filtro = {
                categoria: categoria,
                id: resultado.id,
                nome: resultado.valor
            };
            filtro.codigo = `${filtro.id}_${filtro.nome}`;

            const adicionado = this.resultadosSelecionados.find(
                c => c.codigo === filtro.codigo
            );

            if (!adicionado) {
                this.resultadosSelecionados.push(filtro);
            }
        },

        aplicarFiltros() {
            const filtros = {
                idTerritorios: this.resultadosSelecionados
                    .filter(t => t.categoria === 'TERRITORIO')
                    .map(t => t.id),
                idRepresentantes: this.resultadosSelecionados
                    .filter(r => r.categoria === 'REPRESENTANTE')
                    .map(r => r.id),
                idMunicipios: this.resultadosSelecionados
                    .filter(m => m.categoria === 'MUNICIPIO')
                    .map(m => m.id),
                idCars: this.resultadosSelecionados
                    .filter(c => c.categoria === 'CAR')
                    .map(c => c.id)
            };

            this.tags = [...this.resultadosSelecionados];

            if (this.biomaSelecionado.id) {
                this.tags.push({
                    id: this.biomaSelecionado.codigo,
                    nome: this.biomaSelecionado.nome,
                    codigo: 'BIOMA'
                });
                filtros.idBiomas = [this.biomaSelecionado.id];
            }

            if (this.estadoSelecionado.id && this.municipioSelecionado.id) {
                this.tags.push({
                    id: this.estadoSelecionado.id,
                    nome: `${this.municipioSelecionado.nome}/${this.estadoSelecionado.sigla}`,
                    codigo: 'ESTADO_MUNICIPIO'
                });
                filtros.idEstado = this.estadoSelecionado.id;
                filtros.idMunicipio = this.municipioSelecionado.id;
            }
            this.tags.sort((a, b) => a.nome.localeCompare(b.nome));

            this.$emit('atualizar-filtro', filtros);
        },

        abrirCollapse(collapse) {
            if (collapse) {
                try {
                    const acao = this.acaoCollapse[collapse];
                    if (!this[collapse].length) {
                        this[acao.callback]();
                    }
                } catch (error) {
                    this.exibirNotify(
                        'error',
                        'Não foi possível buscar os dados.'
                    );
                    // eslint-disable-next-line no-throw-literal
                    throw `Ação não registrada para o collapse: ${collapse}, ERRRO: ${error}`;
                }
            }
        },

        removerFiltro(filtro) {
            this.tags.splice(this.tags.indexOf(filtro), 1);
            this.desmarcarFiltroPopover(filtro);
            this.aplicarFiltros();
        },

        desmarcarFiltroPopover(filtro) {
            this.resultadosSelecionados = this.resultadosSelecionados.filter(
                c => c.codigo !== filtro.codigo
            );

            if (filtro.codigo === 'BIOMA') {
                this.biomaSelecionado = '';
            }

            if (filtro.codigo === 'ESTADO_MUNICIPIO') {
                this.estadoSelecionado = '';
                this.municipioSelecionado = '';
            }
        },

        limparFiltros() {
            [...this.tags].forEach(tag => this.removerFiltro(tag));
        },

        buscarBiomas() {
            BiomaService.buscar()
                .then(({ data }) => {
                    setTimeout(() => {
                        this.biomas = data;
                    }, 500);
                })
                .catch(error => {
                    this.exibirNotify(
                        'error',
                        'Não foi possível buscar os dados de biomas.'
                    );
                    throw error;
                });
        },

        buscarEstados() {
            LocalidadeService.findEstados(false)
                .then(({ data }) => {
                    setTimeout(() => {
                        this.estados = data;
                    }, 500);
                })
                .catch(error => {
                    this.exibirNotify(
                        'error',
                        'Não foi possível buscar os dados de estados.'
                    );
                    throw error;
                });
        },

        buscarMunicipios() {
            LocalidadeService.findMunicipios(this.estadoSelecionado.id, false)
                .then(({ data }) => {
                    this.municipioSelecionado = null;
                    setTimeout(() => {
                        this.municipios = data;
                    }, 500);
                })
                .catch(error => {
                    this.exibirNotify(
                        'error',
                        'Não foi possível buscar os dados de municipio.'
                    );
                    throw error;
                });
        },

        exibirNotify(tipo, message) {
            this.$notify[tipo]({
                message
            });
        },
        validarRotaComParametro() {
            if (this.$route.params.valor && this.$route.params.id) {
                let resultado;
                let categoria;
                let valor = this.$route.params.valor;
                let tipo = valor.substring(0, valor.indexOf('=='));
                if (tipo === 'REPRESENTANTE') {
                    let idRepresentante = this.$route.params.id;
                    categoria = tipo;
                    resultado = {
                        id: idRepresentante,
                        valor: valor.substring(valor.indexOf('==') + 2)
                    };
                }
                if (tipo === 'TERRITORIO') {
                    categoria = tipo;
                    let idTerritorio = this.$route.params.id;
                    resultado = {
                        id: idTerritorio,
                        valor: valor.substring(valor.indexOf('==') + 2)
                    };
                }
                this.adicionarResultado(resultado, categoria);
                this.aplicarFiltros();
            }
        },
        validarRotaSemParametro() {
            if (!this.$route.params.valor && !this.$route.params.id) {
                let filtros = {
                    idEstado: null,
                    idMunicipio: null,
                    idBiomas: [],
                    idTerritorios: [],
                    idRepresentantes: []
                };
                this.$emit('atualizar-filtro', filtros);
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.filtros {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
}

.pesquisa-inteligente__container {
    width: 100%;
    height: 42px;
    border-radius: 5px;
    background: var(--white);
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
    position: relative;
    margin-right: 10px;
}

.pesquisa-inteligente__barra-pesquisa {
    height: 100%;
    display: flex;
    justify-content: center;

    i.el-icon-search {
        color: var(--primary);
        font-size: 25px;
        font-weight: bold;
        display: flex;
        align-items: center;
        margin: 0 8px;
    }

    input {
        width: 100%;
        height: 100%;
        border: none;
        outline: none;
        border-radius: 5px;
        color: var(--primary);
    }
}

.pesquisa-inteligente__resultado {
    position: absolute;
    width: 100%;
}

.pesquisa-inteligente__ul {
    list-style: none;
    padding: 8px 0 8px 24px;
    position: relative;
    z-index: 42;
    margin-top: 5px;
    border-radius: 5px;
    background-color: var(--white);
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);

    li {
        padding-left: 18px;
        margin-top: 5px;
        cursor: pointer;
    }
}

.pesquisa-inteligente__categoria {
    font-weight: bold;
}

.filtros-avancados__cabecalho {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.filtros-avancados__aplicar-filtro {
    cursor: pointer;
    border: 1px solid #eeeeee;
    border-radius: 20px;
    padding: 4px 8px;
    color: var(--primary);
}

.pesquisa-inteligente-novo-monitoramento__filtros-selecionados {
    display: flex;
    align-items: center;
    gap: 4px;
}

.filtros-selecionados__limpar {
    cursor: pointer;
}

.el-collapse-item__biomas {
    display: flex;
    flex-wrap: wrap;
    gap: 16px 32px;
}
</style>
